@defer (when isReady()) {
  <section>
    @if (building.licenses && building.licenses.length) {
      <table class="table table-hover mt-1">
        <thead>
          <th class="text-left">License</th>
          <th class="text-right">Value</th>
          <th class="text-right expire">License Expires</th>
        </thead>
        <tbody>
          @for (license of building.licenses; track license) {
            <tr (click)="setBuildingLicense(building, license)">
              <td>
                {{ license.package.title }}
                @if (!license.isActive) {
                  <span class="badge">disabled</span>
                }
              </td>
              <td class="text-right">{{ license.value }}</td>
              <td class="text-right">
                @if (license.expiresAt) {
                  <span>{{ license.expiresAt | amDateFormat: 'DD MMM YYYY' }}</span>
                }
                @if (!license.expiresAt) {
                  <span>No license</span>
                }
              </td>
            </tr>
          }
        </tbody>
      </table>
    }

    @if (building.licenses && !building.licenses.length) {
      <section>
        <app-theme-page-section title="Create building license">
          <app-building-license-home [building]="building" [gateway]="null" (onSave)="licenseUpdated()"> </app-building-license-home>
        </app-theme-page-section>
      </section>
    }

    @if (!building.licenses) {
      <i class="fa fa-spin fa-fw fa-refresh"></i>
    }

    <!-- GATEWAYS -->

    <table class="table table-hover">
      <thead>
        <tr>
          <th>Gateway</th>
          <th>Title</th>
          <th>Status</th>
          <th>License</th>
          <th class="text-right">Value</th>
          <th class="text-right expire">License Expires</th>
        </tr>
      </thead>
      <tbody>
        @for (gateway of gateways; track gateway) {
          <tr (click)="setGatewayLicense(gateway)">
            <td>{{ gateway.id }}</td>
            <td>{{ gateway.title }}</td>
            <td>{{ gateway.statusTitle }}</td>
            @if (!gateway.license?.id) {
              <td colspan="3" class="text-center"><i>-- Included in building license --</i></td>
            } @else {
              <td>
                {{ gateway.license.package.title }}
                @if (!gateway.license.isActive) {
                  <span class="badge">disabled</span>
                }
              </td>
              <td class="text-right">
                {{ gateway.license.value }}
              </td>

              <td class="text-right">
                @if (gateway.license) {
                  <span>{{ gateway.license.expiresAt | amDateFormat: 'DD MMM YYYY' }}</span>
                }
              </td>
            }
          </tr>
        }
      </tbody>
    </table>
    @if (!gateways) {
      <i class="fa fa-spin fa-fw fa-refresh"></i>
    }
  </section>

  <!--
<section *ngIf="selected">
  <app-theme-page-section>
    <app-theme-page-container
      [title]="'License ' + (selected.gateway ? ' for gateway ' + selected.gateway.title : 'for building')"
      [canClose]="true" (onClose)="selected=null">
      <app-theme-page-section>
        <app-building-license-home [building]="building" [gateway]="selected.gateway"
          (onSave)="licenseUpdated($event)">
        </app-building-license-home>
      </app-theme-page-section>
    </app-theme-page-container>
  </app-theme-page-section>
</section>
-->
} @placeholder {
  <i class="mdi mdi-loading mdi-spin-x2"></i>
}
<app-theme-page-section>
  <ul>
    <li>Each building has a "default" license that covers all unlicensed gateways in the building</li>
    <li>Licenses can be added to specific gateways</li>
  </ul>
</app-theme-page-section>

@switch (dialogOpen()) {
  @case ('license') {
    <app-dialog (onClose)="dialogOpen.set(null)" [header]="license.title" [dimensions]="{ width: 1100, height: 580 }">
      <app-building-license-home [license]="license" (onSave)="licenseUpdated()"> </app-building-license-home>
    </app-dialog>
  }
}
